import {
  AnswerOption,
  QuestionnaireContent as TQuestionnaireContent,
  UserAnswer,
} from "core/types";

type QuestionnaireWithMergedAnswers =
  | (Omit<TQuestionnaireContent, "questions"> & {
      questions: Omit<TQuestionnaireContent["questions"], "userAnswer"> & {
        userAnswer: AnswerOption | undefined;
      };
    })
  | undefined;

export const mergeContentWithAnswers = (
  requestId?: string,
  questionnaire?: TQuestionnaireContent,
  patientQuestionnaires?: UserAnswer[],
): QuestionnaireWithMergedAnswers => {
  if (!requestId || !questionnaire) return undefined;

  const relevantAnswers = requestId
    ? patientQuestionnaires?.filter(
        (answer) =>
          answer.surveyId === questionnaire.clinicalId &&
          answer.requestId === requestId,
      )
    : [];

  const mergedWithAnswers = {
    ...questionnaire,
    questions: questionnaire.questions.map((question) => {
      return {
        ...question,
        userAnswer: question.optionGroup.options.find(
          (option) =>
            option.optionId ===
            relevantAnswers?.find(
              (answer) => answer.questionId === question.questionId,
            )?.answerId,
        ),
      };
    }),
  } as QuestionnaireWithMergedAnswers;
  return mergedWithAnswers;
};
